<template>
  <div class="about-us-page-view">
    <div class="about">
      <h1>{{$t('aboutUs.Abuout Us')}}</h1>
      <b style="font-size: 16px;">{{$t('aboutUs.Shelf Label Solutions')}}</b><br/><br/>
      <!-- <p>{{$t('aboutUs.paragraph1')}}</p>
      <p>{{$t('aboutUs.paragraph2')}}</p>
      <p>{{$t('aboutUs.paragraph3')}}</p>
      <p>{{$t('aboutUs.paragraph4')}}</p>
      <p>{{$t('aboutUs.paragraph5')}}</p>
      <p>{{$t('aboutUs.paragraph6')}}</p>
      <p>{{$t('aboutUs.paragraph7')}}</p> -->
    </div>
	</div>
</template>
<script>
  export default {
    name:'',
    components: {
    },
    props: {},
    data() {
      return {
        list:[]
      }
    },
    methods: {
    }
  }
</script>
<style lang="scss" scoped>
  .about-us-page-view{
    .about{
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.05);
      padding: 15px;
      // width: 60%;
      width: 100%;
    }
		.about h1{
      border-bottom: 1px #eee solid;
      padding-bottom: 10px;
      font-size: 14px;
      font-weight: normal;
    }
  } 
</style>